module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-genio-localizza",
      "title": "Localizzazione"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b3faea0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/GenioLocalizza.vue
// module id = 847
// module chunks = 39